//
//
//
//

// TODO: add element-id in product-tile
import RbProductTile from '@/elements/product-tile/rb-product-tile.vue'
import EditorialProduct from '@/scripts/libs/wcs/editorial-product'

export default {
  name: 'rb-editorial-product-tile',
  components: {
    RbProductTile,
  },
  props: {
    product: Object,
    dataElementId: {
      type: String,
      default: '',
    },
  },
  computed: {
    productMap() {
      return EditorialProduct.normalizeProduct(this.product)
    },
  },
}
